import { create } from '@/shared/lib/zustand';
import { immer } from 'zustand/middleware/immer';

type AiInsightPanelState = {
  isOpen: boolean;
};

type AiInsightPanelActions = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

/**
 * Whether the AI Insight panel is expanded.
 *
 * Global rather than local for the same reason as the tab store: Portfolio Mode
 * and Single Mode render different trees, and the panel must not slam shut when
 * the user picks a facility in the header.
 *
 * Deliberately NOT persisted. Opening the panel triggers a generation, so a
 * remembered "open" would bill an API call on every fresh page load before the
 * user has asked for anything.
 */
export const useAiInsightPanelStore = create<
  AiInsightPanelState & AiInsightPanelActions
>()(
  immer((set) => ({
    isOpen: false,
    open: () => {
      set((state) => {
        state.isOpen = true;
      });
    },
    close: () => {
      set((state) => {
        state.isOpen = false;
      });
    },
    toggle: () => {
      set((state) => {
        state.isOpen = !state.isOpen;
      });
    },
  }))
);
